.root {
  display: grid;
  width: 100%;
  min-width: 0;
  gap: var(--space-2);
  padding: var(--space-3);
  border-radius: var(--radius-md);
  background: var(--color-play-mode-chip-bg);
}

.label {
  font-size: var(--mantine-font-size-xs);
  font-weight: 700;
  line-height: 1.3;
}

.items {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
  font-size: var(--mantine-font-size-sm);
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}
